import React from 'react';
import { ITransactionOpportunity } from '@sp-types/transactionOpportunityType';
import { OpportunityDoughChart } from './components/OpRouteDistribution';
import { RoutesProfitBar } from './components/OpRouteProfit';
import { SummaryData } from './components/OpSummaryDashboardSummary';

interface Props {
  data: ITransactionOpportunity[];
}

export const OpportunitySummaryDashboard: React.FC<Props> = ({ data }) => {
  return (
    <div className="flex flex-1 flex-row bg-white py-4 px-6 ">
      <div className="flex flex-1  border-gray-100 ">
        <SummaryData data={data} />
      </div>
      <div className="flex flex-1 border-l-2 border-gray-100 ps-8">
        <OpportunityDoughChart data={data} />
      </div>
      <div className="flex flex-1 border-l-2 border-gray-100 ps-8">
        <RoutesProfitBar data={data} />
      </div>
    </div>
  );
};
